(() => {
  const roots = document.querySelectorAll('[data-sleeping-bag-details]');

  const decodeText = (value) => {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = value || '';
    return decoder.value.replace(/\s+/g, ' ').trim();
  };

  const decimal = (value) => String(value || '').replace('.', ',');
  const paragraph = (heading, text) => `<p><strong>${heading}</strong>${text}</p>`;
  const degree = (value) => `${String(value).replace('-', '−')} °C`;

  const formatDimensions = (value) =>
    String(value || '')
      .replace(/\s*[x×]\s*/gi, ' × ')
      .replace(/\s*\/\s*/g, '/')
      .replace(/\./g, ',')
      .replace(/\s+/g, ' ')
      .trim();

  const findTemperature = (text) => {
    const range = text.match(/Komfort[- ]?temperatur(?:grænse)?\s*(?::|på)?\s*(-?\d+)\s*(?:-|–|til)\s*(-?\d+)\s*(?:grader|°)?/i);
    const single = text.match(/Komfort[- ]?temperatur(?:grænse)?\s*(?::|på)?\s*(-?\d+)\s*(?:grader|°)?/i);
    const lower = text.match(/(?:Nedre\s+temperaturgrænse|Temperaturgrænse)\s*:?\s*(-?\d+)\s*(?:grader|°)?/i);

    if (range) {
      return { value: `${range[1].replace('-', '−')}–${range[2].replace('-', '−')} °C`, comfort: true, lower: lower ? lower[1] : '' };
    }
    if (single) return { value: degree(single[1]), comfort: true, lower: lower ? lower[1] : '' };
    if (lower) return { value: `Ned til ${degree(lower[1])}`, comfort: false, lower: lower[1] };
    return null;
  };

  const findSeasons = (text) => {
    const match = text.match(/(\d+(?:\s*1\/2)?)\s*sæsons?/i);
    if (!match) return '';
    return match[1].replace(/\s*1\/2/, '½');
  };

  const findFit = (text) => {
    const range = text.match(/Passer\s+til\s+børn\s+(\d+)\s*(?:-|–)\s*(\d+)\s*cm/i);
    if (range) return { value: `${range[1]}–${range[2]} cm`, child: true };
    const max = text.match(/Passer\s+til\s+(?:personer|børn)\s+op\s+til\s+(\d+)\s*cm/i);
    if (max) return { value: `Op til ${max[1]} cm`, child: /børn/i.test(max[0]) };
    return null;
  };

  const findSize = (text) => {
    const explicit = text.match(/(?:Størrelse\s*:\s*)?(\d+\s*[x×]\s*\d+(?:\s*\/\s*\d+)?)\s*cm/i);
    if (explicit) return `${formatDimensions(explicit[1])} cm`;
    const length = text.match(/Længden\s+er\s+(\d+)\s*cm/i);
    return length ? `${length[1]} cm lang` : '';
  };

  const findWeight = (text) => {
    const includingBag = text.match(/Kun\s+(\d{3,4})(?:\s*g)?\s+inkl\.?\s+bærepose/i);
    if (includingBag) return Number(includingBag[1]);

    const matches = [...text.matchAll(/(\d{3,4})\s*g\b(?!\s*\/\s*m2)/gi)];
    if (!matches.length) return null;
    return Number(matches[matches.length - 1][1]);
  };

  const findFill = (text) => {
    const fillPower = text.match(/(?:Fyldekraft\s*:\s*)?([+]?\d+)\s*cuin/i);
    const fillWeight = text.match(/(\d+)\s*g\s*\/\s*m2\s*fyld/i) || text.match(/Fyld\s*:\s*100%\s*andedun\s*\((\d+)\s*g\)/i);
    if (/gåsedun/i.test(text)) {
      return { value: `Gåsedun${fillPower ? ` · ${fillPower[1].replace('+', '')} cuin` : ''}`, type: 'goose', fillWeight: fillWeight ? fillWeight[1] : '' };
    }
    if (/andedun/i.test(text)) {
      return { value: `Andedun${fillPower ? ` · ${fillPower[1].replace('+', '')} cuin` : ''}`, type: 'duck', fillWeight: fillWeight ? fillWeight[1] : '' };
    }
    if (/Hollowfibre/i.test(text)) return { value: 'Hollowfibre', type: 'synthetic', fillWeight: '' };
    if (fillWeight) return { value: `${fillWeight[1]} g/m²`, type: 'synthetic', fillWeight: fillWeight[1] };
    return null;
  };

  const buildTemperature = (temperature) => {
    if (!temperature) {
      return {
        value: 'Ikke oplyst',
        body: paragraph('Temperaturgrænsen er ikke oplyst.', ' Vælg tøj og liggeunderlag efter vejret, og medbring ekstra isolering på kølige nætter.'),
      };
    }

    const lowerCopy = temperature.lower
      ? paragraph('Nedre temperaturgrænse.', ` Producenten angiver ${degree(temperature.lower)} som den nedre grænse. Det er en sikkerhedsmargin – ikke den temperatur, hvor de fleste sover mest behageligt.`)
      : '';

    return {
      value: temperature.value,
      body: temperature.comfort
        ? paragraph('Temperaturen for en behagelig nat.', ` Den angivne komforttemperatur er ${temperature.value}. Den er det bedste udgangspunkt, når soveposen skal matches med årstid og vejr.`) +
          paragraph('Din oplevelse kan variere.', ' Kuldefølsomhed, vind, fugt, nattøj og liggeunderlagets isolering påvirker, hvor varmt du sover.') + lowerCopy
        : paragraph('Dette er den nedre temperaturgrænse.', ` Soveposen er angivet til ned til ${degree(temperature.lower)}. Ved denne temperatur kan komforten være begrænset, især hvis du er kuldskær.`) +
          paragraph('Planlæg med en sikkerhedsmargin.', ' Brug et isolerende liggeunderlag og vælg gerne en varmere sovepose end minimumsbehovet.')
    };
  };

  const buildSeasons = (seasons) => {
    if (!seasons) return { value: 'Ikke oplyst', body: paragraph('Antallet af sæsoner er ikke oplyst.', ' Brug temperaturangivelsen som dit primære valgkriterium.') };
    const numeric = Number.parseFloat(seasons.replace('½', '.5'));
    let use = 'sommer, festival og milde nætter';
    if (numeric >= 4) use = 'kolde nætter og brug gennem det meste af året';
    else if (numeric >= 3) use = 'forår, sommer og efterår';

    return {
      value: `${seasons} ${seasons === '1' ? 'sæson' : 'sæsoner'}`,
      body: paragraph(`${seasons}-sæsons sovepose.`, ` Den er udviklet til ${use}. Sæsonangivelsen er en enkel vejledning og bør altid læses sammen med temperaturgrænserne.`) +
        paragraph('Vejret afgør det endelige valg.', ' Vind, fugt og overnatningsform kan gøre samme temperatur markant koldere eller varmere.'),
    };
  };

  const buildFit = (fit) => {
    if (!fit) return { value: 'Ikke oplyst', body: paragraph('Anbefalet personhøjde er ikke oplyst.', ' Sammenlign din højde med soveposens længde, og sørg for lidt fri plads ved fødderne.') };
    return {
      value: fit.value,
      body: fit.child
        ? paragraph('Tilpasset børn.', ` Soveposen passer til børn på ${fit.value.toLowerCase()}. Den kortere pasform reducerer tom luft, som kroppen ellers skal varme op.`) +
          paragraph('Kontrollér barnets højde.', ' Der bør være lidt plads ved fødderne, men ikke så meget, at soveposen bliver unødigt vanskelig at varme op.')
        : paragraph('Anbefalet maksimal højde.', ` Soveposen passer til personer ${fit.value.toLowerCase()}. En korrekt længde giver plads til fødderne uden unødigt stort luftvolumen.`) +
          paragraph('Pasformen påvirker varmen.', ' Hvis soveposen er meget for stor, skal kroppen opvarme mere luft. Er den for kort, kan isoleringen blive presset flad.'),
    };
  };

  const buildSize = (size, text) => {
    if (!size) return { value: 'Ikke oplyst', body: paragraph('Målene er ikke oplyst.', ' Brug den anbefalede personhøjde til at vurdere pasformen.') };
    const mummy = /mumie|mummy|\d+\s*[x×]\s*\d+\s*\/\s*\d+/i.test(text);
    return {
      value: size,
      body: paragraph(mummy ? 'Formet omkring kroppen.' : 'Rummelig, klassisk form.', mummy
        ? ` Målene er ${size}. Den smallere fodende reducerer tom luft og gør soveposen lettere at varme op.`
        : ` Målene er ${size}. Den lige form giver god bevægelsesfrihed og kan på udvalgte modeller lynes helt op som dyne.`) +
        paragraph('Sammenlign med din sovestil.', ' En smal pasform holder bedre på varmen, mens ekstra bredde er behagelig, hvis du bevæger dig meget i søvne.'),
    };
  };

  const buildFill = (fill) => {
    if (!fill) return { value: 'Ikke oplyst', body: paragraph('Fyldtypen er ikke oplyst.', ' Temperaturangivelsen er derfor det bedste grundlag for at vurdere soveposens varme.') };
    if (fill.type === 'goose' || fill.type === 'duck') {
      const bird = fill.type === 'goose' ? 'gåsedun' : 'andedun';
      return {
        value: fill.value,
        body: paragraph(`Isolering med ${bird}.`, ' Dun giver meget varme i forhold til vægten og kan komprimeres til en lille pakke. Det er en fordel til vandring og ture med begrænset plads.') +
          paragraph('Fyldkraften beskriver spændstigheden.', fill.value.includes('cuin')
            ? ` Den angivne cuin-værdi viser, hvor meget dunene udvider sig. En højere værdi giver mere isolerende luft pr. gram fyld.`
            : ' Dunene bør opbevares løst og helt tørt mellem turene, så de bevarer deres spændstighed.'),
      };
    }
    return {
      value: fill.value,
      body: paragraph('Syntetisk isolering.', ` Fyldet er ${fill.value}. Syntetisk fyld er robust, nemt at vedligeholde og bevarer en del af isoleringen, selv hvis det bliver fugtigt.`) +
        paragraph('Praktisk til dansk udeliv.', ' Det er et godt valg til camping, festival og ture, hvor vejr og fugt kan skifte.'),
    };
  };

  const buildWeight = (grams) => {
    if (!grams) return { value: 'Ikke oplyst', body: paragraph('Vægten er ikke oplyst.', ' Hvis soveposen skal bæres langt, anbefaler vi at få den præcise vægt bekræftet før køb.') };
    let lead = 'God balance mellem varme og vægt.';
    let copy = ' Den passer godt til camping og ture, hvor oppakningen kun bæres kortere afstande.';
    if (grams <= 1000) {
      lead = 'Lav vægt til en kompakt oppakning.';
      copy = ' Den er særligt velegnet til vandring, cykelture og andre ture, hvor hvert gram har betydning.';
    } else if (grams >= 2000) {
      lead = 'Varme og komfort prioriteres.';
      copy = ' Den højere vægt passer bedst til camping og ture, hvor soveposen transporteres i bil eller kun bæres kort.';
    }
    return {
      value: grams >= 1000 ? `${decimal((grams / 1000).toFixed(grams % 1000 === 0 ? 0 : 2).replace(/0$/, ''))} kg` : `${grams} g`,
      body: paragraph(lead, copy) + paragraph('Se på hele sovesystemet.', ' Liggeunderlag, pude, lagen og opbevaringspose tæller også med i den samlede oppakningsvægt.'),
    };
  };

  roots.forEach((root) => {
    const source = root.querySelector('[data-sleeping-bag-product-data]');
    if (!source) return;

    let product;
    try {
      product = JSON.parse(source.textContent);
    } catch (error) {
      return;
    }

    const title = decodeText(product.title);
    const text = decodeText(product.description);
    const data = {
      temperature: buildTemperature(findTemperature(text)),
      seasons: buildSeasons(findSeasons(text)),
      fit: buildFit(findFit(text)),
      size: buildSize(findSize(text), `${title} ${text}`),
      fill: buildFill(findFill(text)),
      weight: buildWeight(findWeight(text)),
    };

    root.querySelectorAll('[data-bag-detail]').forEach((item) => {
      const detail = data[item.dataset.bagDetail];
      if (!detail) return;
      item.querySelector('[data-detail-value]').textContent = detail.value;
      item.querySelector('[data-detail-body]').innerHTML = detail.body;
    });

    const details = root.querySelectorAll('details');
    details.forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        details.forEach((other) => {
          if (other !== detail) other.open = false;
        });
      });
    });

    root.hidden = false;
  });
})();
